export default function (other) {
  other = other || {}
  return {
    color: other.color || null,
    status: other.status || null,

  }
}
